import { render, staticRenderFns } from "./Friend.vue?vue&type=template&id=50166364"
import script from "./Friend.vue?vue&type=script&lang=js"
export * from "./Friend.vue?vue&type=script&lang=js"
import style0 from "./Friend.vue?vue&type=style&index=0&id=50166364&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports